import i18n from '@/locales/i18n'

var trackConfig = function () {
	return [
		{
			code: 'DOOR_ARRIVED',
			msg: i18n.t('businessDispatch.arriveFactory'),
			titleConfig: {
				label: i18n.t('businessDispatch.arriveFactoryTime'), // 控制不展示時間控件
				dateHolder: i18n.t('businessDispatch.factoryInfoAwaitingFeedback'),
				dialogTitle: i18n.t('businessDispatch.factoryInfoFeedback'),
				imgHolder: i18n.t('businessDispatch.factoryInfoFeedbackImage')
			},
			fileConfig: {
				IB: [
					{
						msg: i18n.t('businessDispatch.factoryDoorPhoto'),
						uploadHolder: `${i18n.t('upload')} ${i18n.t('businessDispatch.factoryDoorPhoto')}`,
						fileType: 'DOOR_ARRIVED_IMAGE',
						fileCount: 10,
						files: [],
					}
				],
				OB: [
					{
						msg: i18n.t('businessDispatch.factoryDoorPhoto'),
						uploadHolder: `${i18n.t('upload')} ${i18n.t('businessDispatch.factoryDoorPhoto')}`,
						fileType: 'DOOR_ARRIVED_IMAGE',
						fileCount: 10,
						files: [],
					}
				]
			}
		},
		{
			code: 'DOOR_LEFT',
			msg: i18n.t('businessDispatch.leaveFactory'),
			titleConfig: {
				label: i18n.t('businessDispatch.leaveFactoryTime'),
				dateHolder: i18n.t('businessDispatch.departureInformationAwaitingFeedback'),
				dialogTitle: i18n.t('businessDispatch.departureInformationFeedback'),
				imgHolder: i18n.t('businessDispatch.departureInformationFeedbackImage')
			},
			fileConfig: {
				IB: [
					{
						msg: i18n.t('businessDispatch.factoryReceipt'),
						uploadHolder: `${i18n.t('upload')} ${i18n.t('businessDispatch.factoryReceipt')}`,
						fileType: 'DOOR_LEFT_SIGN_RECEIPT',
						fileCount: 10,
						files: [],
					}
				],
				OB: [
					{
						msg: i18n.t('businessDispatch.packingPhoto'),
						uploadHolder: `${i18n.t('upload')} ${i18n.t('businessDispatch.packingPhoto')}`,
						fileType: 'DOOR_LEFT_SEAL_IMAGE',
						fileCount: 10,
						files: [],
					},
					{
						msg: i18n.t('businessDispatch.viewPackingList'),
						uploadHolder: `${i18n.t('upload')} ${i18n.t('businessDispatch.viewPackingList')}`,
						fileType: 'DOOR_LEFT_CLP_IMAGE',
						fileCount: 10,
						files: [],
					}
				]
			}
		},
		{
			code: 'RETURN_CONTAINER',
			msg: i18n.t('businessDispatch.returnBox'),
			titleConfig: {
				label: i18n.t('businessDispatch.returnBoxTime'),
				desc: i18n.t('businessDispatch.confirmReturnBoxTime'),
				dateHolder: i18n.t('businessDispatch.returnBoxInfoAwaitingFeedback'),
				dialogTitle: i18n.t('businessDispatch.returnBoxInfoFeedback'),
				imgHolder: i18n.t('businessDispatch.returnContainerFeedbackImage')
			},
			fileConfig: {
				IB: [
					{
						msg: i18n.t('businessDispatch.returnContainerPhoto'),
						uploadHolder: `${i18n.t('upload')} ${i18n.t('businessDispatch.returnContainerPhoto')}`,
						fileType: 'FILE_UPLOAD_RETURN_BOX',
						fileCount: 10,
						files: [],
					}
				],
				OB: [
					{
						msg: i18n.t('businessDispatch.returnContainerPhoto'),
						uploadHolder: `${i18n.t('upload')} ${i18n.t('businessDispatch.returnContainerPhoto')}`,
						fileType: 'FILE_UPLOAD_RETURN_BOX',
						fileCount: 10,
						files: [],
					}
				]
			}
		}
	];
};

export { trackConfig }